<template>
  <div>Documents</div>
</template>

<script>
export default {
  name: "Documents",
};
</script>